export default [
  {
    id: 1,
    name_jp: 'あむあむ',
    name_en: 'Amuamu',
  },
  {
    id: 2,
    name_jp: 'いもいも',
    name_en: 'Imoimo',
  },
  {
    id: 3,
    name_jp: 'うたうた',
    name_en: 'Utauta',
  },
  {
    id: 4,
    name_jp: 'えとえと',
    name_en: 'Etoeto',
  },
  {
    id: 5,
    name_jp: 'おりおり',
    name_en: 'Oriori',
  },
  {
    id: 6,
    name_jp: 'かむかむ',
    name_en: 'Kamukamu',
  },
  {
    id: 7,
    name_jp: 'きときと',
    name_en: 'Kitokito',
  },
  {
    id: 8,
    name_jp: 'くすくす',
    name_en: 'Kusukusu',
  },
  {
    id: 9,
    name_jp: 'けめけめ',
    name_en: 'Kemekeme',
  },
  {
    id: 10,
    name_jp: 'こちこち',
    name_en: 'Kochikochi',
  },
  {
    id: 11,
    name_jp: 'さまさま',
    name_en: 'Samasama',
  },
  {
    id: 12,
    name_jp: 'しぴしぴ',
    name_en: 'Shipishipi',
  },
  {
    id: 13,
    name_jp: 'すめすめ',
    name_en: 'Sumesume',
  },
  {
    id: 14,
    name_jp: 'せろせろ',
    name_en: 'Serosero',
  },
  {
    id: 15,
    name_jp: 'そいそい',
    name_en: 'Soisoi',
  },
  {
    id: 16,
    name_jp: 'たりたり',
    name_en: 'Taritari',
  },
  {
    id: 17,
    name_jp: 'ちみちみ',
    name_en: 'Chimichimi',
  },
  {
    id: 18,
    name_jp: 'つとつと',
    name_en: 'Tsutotsuto',
  },
  {
    id: 19,
    name_jp: 'てろてろ',
    name_en: 'Terotero',
  },
  {
    id: 20,
    name_jp: 'とくとく',
    name_en: 'Tokutoku',
  },
  {
    id: 21,
    name_jp: 'なみなみ',
    name_en: 'Naminami',
  },
  {
    id: 22,
    name_jp: 'にんにん',
    name_en: 'Ninnin',
  },
  {
    id: 23,
    name_jp: 'ぬいぬい',
    name_en: 'Nuinui',
  },
  {
    id: 24,
    name_jp: 'ねじねじ',
    name_en: 'Nejineji',
  },
  {
    id: 25,
    name_jp: 'のこのこ',
    name_en: 'Nokonoko',
  },
  {
    id: 26,
    name_jp: 'はくはく',
    name_en: 'Hakuhaku',
  },
  {
    id: 27,
    name_jp: 'ぴとぴと',
    name_en: 'Pitopito',
  },
  {
    id: 28,
    name_jp: 'ぷくぷく',
    name_en: 'Pukupuku',
  },
  {
    id: 29,
    name_jp: 'へまへま',
    name_en: 'Hemahema',
  },
  {
    id: 30,
    name_jp: 'ぽてぽて',
    name_en: 'Potepote',
  },
  {
    id: 31,
    name_jp: 'ましまし',
    name_en: 'Mashimashi',
  },
  {
    id: 32,
    name_jp: 'みそみそ',
    name_en: 'Misomiso',
  },
  {
    id: 33,
    name_jp: 'むーむー',
    name_en: 'Mumu',
  },
  {
    id: 34,
    name_jp: 'めけめけ',
    name_en: 'Mekemeke',
  },
  {
    id: 35,
    name_jp: 'もぎもぎ',
    name_en: 'Mogimogi',
  },
  {
    id: 36,
    name_jp: 'やくやく',
    name_en: 'Yakuyaku',
  },
  {
    id: 37,
    name_jp: 'ゆりゆり',
    name_en: 'Yuriyuri',
  },
  {
    id: 38,
    name_jp: 'よんよん',
    name_en: 'Yonyon',
  },
  {
    id: 39,
    name_jp: 'らそらそ',
    name_en: 'Rasoraso',
  },
  {
    id: 40,
    name_jp: 'りんりん',
    name_en: 'Rinrin',
  },
  {
    id: 41,
    name_jp: 'るりるり',
    name_en: 'Ruriruri',
  },
  {
    id: 42,
    name_jp: 'ればれば',
    name_en: 'Rebareba',
  },
  {
    id: 43,
    name_jp: 'ろぴろぴ',
    name_en: 'Ropiropi',
  },
  {
    id: 44,
    name_jp: 'わしわし',
    name_en: 'Washiwashi',
  },
];
